import React from 'react';
import './MatchComponent.css';

const MatchComponent = ({ team1, team2, matchId, selectedWinner, onWinnerSelect, disabled = false }) => (
  <div className="match-container">
    <div className="match-teams">
      <div className="team-section">
        <div className="team-label"></div>
        <button
          className={`team-button ${selectedWinner === team1 ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => !disabled && onWinnerSelect(team1)}
          disabled={disabled}
        >
          {team1}
        </button>
      </div>
      <div className="vs">VS</div>
      <div className="team-section">
        <div className="team-label"></div>
        <button
          className={`team-button ${selectedWinner === team2 ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
          onClick={() => !disabled && onWinnerSelect(team2)}
          disabled={disabled}
        >
          {team2}
        </button>
      </div>
    </div>
  </div>
);

export default MatchComponent;
